import axios from "axios";

const ApiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

ApiInstance.interceptors.request.use((config) => {
  return config;
});

ApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error: any) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("hash")
      window.location.pathname !== "/" && (window.location.pathname = "/");
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default ApiInstance;
export { ApiInstance as Api };
